import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
            <span className="text-xs font-semibold text-foreground-500 uppercase tracking-wider">User Reviews</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
            Trusted by Thousands<br />Of Spreadsheet Users
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            Real feedback from our community of pandabuyspreadsheet enthusiasts
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/50"
            >
              <div className="flex gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                {t.name.split(' ')[0]}&apos;s Review
              </h4>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-4">
                {t.text}
              </p>
              <div className="flex items-center gap-3 mt-4 pt-3 border-t border-background-200/50">
                <div className="w-8 h-8 rounded-full overflow-hidden bg-secondary-200 flex-shrink-0">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}